import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { UserGuideModel } from './key-features/types/user-guide-model.interface';
import { UserGuideModelImpl } from './key-features/models/user-guide-model';
import { UserGuideApi } from './key-features/types/user-guide-api.interface';
import { UserGuideApiImpl } from './key-features/repository/user-guide-api';
import { UserGuideService } from './key-features/types/user-guide-service.interface';
import { UserGuideServiceImpl } from './key-features/user-guide-service';
import { AiTaggingTourApi } from './ai-tagging-tour/types/ai-tagging-tour-api.interface';
import { AiTaggingTourApiImpl } from './ai-tagging-tour/repository/ai-tagging-tour-api';
import { AiTaggingTourService } from './ai-tagging-tour/types/ai-tagging-tour-service.interface';
import { AiTaggingTourServiceImpl } from './ai-tagging-tour/ai-tagging-tour-service';
import { UserGuideApiDto } from './key-features/types/user-guide-api-dto.interface';
import { UserGuideApiDtoImpl } from './key-features/repository/user-guide-api-dto';
export const userGuide = new ContainerModule(bind => {
    bind(UserGuideModel).to(UserGuideModelImpl);
    bind(UserGuideApi).to(UserGuideApiImpl);
    bind(UserGuideService).to(UserGuideServiceImpl);
    bind(UserGuideApiDto).to(UserGuideApiDtoImpl);
    bind(AiTaggingTourApi).to(AiTaggingTourApiImpl);
    bind(AiTaggingTourService).to(AiTaggingTourServiceImpl);
});
